import {
  REPORTS_TAB_FEATURE_BY_KEY,
  REPORTS_TAB_VALUE_BY_KEY,
  getLegacyReportsTabs,
  hasReportsTabPermission,
} from "../config/reportsModuleCatalog";
import { getLayoutSection, getPageTitleKey } from "./moduleLayoutUtils";

function resolveTabLabel(widget, t) {
  return t(widget.labelKey || widget.tabKey);
}

function expandLegacyReportsTabs(tabs, t) {
  if (!tabs?.length) return tabs;
  if (tabs.some((tab) => tab.tabKey === "speedAnalytics")) {
    return tabs;
  }

  const expanded = [];
  tabs.forEach((tab) => {
    if (tab.tabKey === "analyticsOverview" || tab.tabKey === "overview") {
      expanded.push({
        ...tab,
        tabKey: "overview",
        labelKey: "Overview",
        label: t("Overview"),
        value: REPORTS_TAB_VALUE_BY_KEY.overview,
      });
      expanded.push(
        {
          tabKey: "speedAnalytics",
          labelKey: "Speed Analytics",
          value: REPORTS_TAB_VALUE_BY_KEY.speedAnalytics,
          feature: REPORTS_TAB_FEATURE_BY_KEY.speedAnalytics,
          label: t("Speed Analytics"),
        },
        {
          tabKey: "tripAnalytics",
          labelKey: "Trip Analytics",
          value: REPORTS_TAB_VALUE_BY_KEY.tripAnalytics,
          feature: REPORTS_TAB_FEATURE_BY_KEY.tripAnalytics,
          label: t("Trip Analytics"),
        },
        {
          tabKey: "routeAnalytics",
          labelKey: "Route Analytics",
          value: REPORTS_TAB_VALUE_BY_KEY.routeAnalytics,
          feature: REPORTS_TAB_FEATURE_BY_KEY.routeAnalytics,
          label: t("Route Analytics"),
        },
        {
          tabKey: "vehicleAnalytics",
          labelKey: "Vehicle Analytics",
          value: REPORTS_TAB_VALUE_BY_KEY.vehicleAnalytics,
          feature: REPORTS_TAB_FEATURE_BY_KEY.vehicleAnalytics,
          label: t("Vehicle Analytics"),
        },
      );
      return;
    }

    if (tab.tabKey === "reports") {
      expanded.push({
        ...tab,
        tabKey: "exportReports",
        labelKey: "Export Reports",
        label: t("Export Reports"),
        icon: "download",
        value: REPORTS_TAB_VALUE_BY_KEY.exportReports,
      });
      return;
    }

    expanded.push(tab);
  });

  return ensureDriverBehaviorTab(expanded, t);
}

function ensureDriverBehaviorTab(tabs, t) {
  if (!tabs?.some((tab) => tab.tabKey === "vehicleAnalytics")) {
    return tabs;
  }
  if (tabs.some((tab) => tab.tabKey === "driverBehavior")) {
    return tabs;
  }

  const behaviorTab = {
    tabKey: "driverBehavior",
    labelKey: "Driver Behavior",
    value: REPORTS_TAB_VALUE_BY_KEY.driverBehavior,
    feature: REPORTS_TAB_FEATURE_BY_KEY.driverBehavior,
    label: t("Driver Behavior"),
  };
  const vehicleIndex = tabs.findIndex((tab) => tab.tabKey === "vehicleAnalytics");
  const next = [...tabs];
  next.splice(vehicleIndex + 1, 0, behaviorTab);
  return next;
}

export function buildReportsTabsFromLayout(layout, { t, features, school = false }) {
  const tabSection = getLayoutSection(layout, "reportsTabBar");
  if (!tabSection?.widgets) return null;

  const tabs = tabSection.widgets
    .map((widget) => ({
      tabKey: widget.tabKey,
      labelKey: widget.labelKey || widget.tabKey,
      value: REPORTS_TAB_VALUE_BY_KEY[widget.tabKey],
      feature: REPORTS_TAB_FEATURE_BY_KEY[widget.tabKey],
      permission: widget.permission || null,
      hideForSchool: Boolean(widget.hideForSchool),
      icon: widget.icon || null,
      order: typeof widget.order === "number" ? widget.order : 0,
    }))
    .filter((tab) => tab.value !== undefined);

  const resolvedTabs = tabs
    .filter((tab) => !school || !tab.hideForSchool)
    .filter((tab) => hasReportsTabPermission(tab.permission, features))
    .sort((a, b) => a.order - b.order)
    .map((tab) => ({
      tabKey: tab.tabKey,
      labelKey: tab.labelKey,
      value: tab.value,
      feature: tab.feature,
      icon: tab.icon,
      label: resolveTabLabel(tab, t),
    }));

  return ensureDriverBehaviorTab(expandLegacyReportsTabs(resolvedTabs, t), t);
}

export { getPageTitleKey, getLegacyReportsTabs };
